<template>
  <el-drawer class="mobile-menu-drawer" v-model="drawerVisible" size="200px" :show-close="false" :with-header="false" direction="ltr">
    <div class="flex h-full">
      <!-- 移动端一级菜单 -->
      <div class="w-[40px] border-r h-full">
        <el-menu :default-active="activeMenuKeys[0]" class="!border-0" @select="handleMainMenuClick">
          <el-menu-item v-for="menu in menus" :key="menu.id" :index="menu.id" class="!p-0 !mx-0">
            <div class="flex flex-col items-center justify-center p-3 text-center">
              <!-- <SymIcon :name="menu.icon" :size="16" class="m-auto" /> -->
            </div>
          </el-menu-item>
        </el-menu>
      </div>

      <!-- 移动端二级菜单 -->
      <div class="flex-1">
        <div class="h-[50px] border-b flex items-center justify-between px-4">
          <span class="text-lg font-semibold">{{ currentMenu?.name }}</span>
          <el-button link @click="closeDrawer">
            <template #icon>
              <el-icon><Close /></el-icon>
            </template>
          </el-button>
        </div>
        <el-menu :default-active="activeSubMenuKeys[0]" style="width: 100%; border-right: none" @select="onClickMenuItem">
          <el-menu-item v-for="menu in currentSubMenus" :key="menu.id" :index="menu.id" class="h-[40px]">
            <template #title>
              <div class="flex items-center">
                <!-- <SymIcon v-if="menu.icon" :name="menu.icon" :size="16" class="mr-1" /> -->
                <span>{{ menu.name }}</span>
              </div>
            </template>
          </el-menu-item>
        </el-menu>
      </div>
    </div>
  </el-drawer>
</template>

<script setup>
import { router } from "@inertiajs/vue3"
import { Close } from '@element-plus/icons-vue'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:visible'])

// 创建双向绑定的计算属性
const drawerVisible = computed({
  get: () => props.visible,
  set: (val) => emit('update:visible', val)
})

// 关闭抽屉的方法
const closeDrawer = () => {
  drawerVisible.value = false
}

const { t } = useI18n()
const { menus, submenus } = useShareData()

const currentMenu = ref(null)
const currentSubMenus = ref([])
const currentSubMenu = ref({})
const activeMenuKeys = ref([])
const activeSubMenuKeys = ref([])

// 根据路由路径设置活动菜单
const setActiveMenuByPath = (path) => {
  if (!path) return

  currentMenu.value = menus.value.find(menu => path.includes(menu.id)) || menus.value[0]
  currentSubMenus.value = submenus.value.filter(menu => menu.parent === currentMenu.value?.id)
  currentSubMenu.value = submenus.value.find(menu => menu.path === path) || submenus.value[0]

  activeMenuKeys.value = [currentMenu.value?.id]
  activeSubMenuKeys.value = [currentSubMenu.value?.id]
}

// 处理主菜单点击
const handleMainMenuClick = (id) => {
  currentMenu.value = menus.value.find(menu => menu.id === id)
  currentSubMenus.value = submenus.value.filter(menu => menu.parent === id)
  activeMenuKeys.value = [id]
  activeSubMenuKeys.value = []
}

// 处理子菜单点击
const onClickMenuItem = (id) => {
  currentSubMenu.value = submenus.value.find(menu => menu.id === id)
  emit('update:visible', false)
  router.visit(currentSubMenu?.value?.path || '/admin')
}

// 监听路由变化
router.on('finish', (event) => {
  const path = event?.detail?.visit?.url?.pathname
  setActiveMenuByPath(path)
})

onMounted(() => {
  setActiveMenuByPath(window?.location?.pathname)
})
</script>
